module.exports = __webpack_public_path__ + "static/media/flower_seller4.d6351b0b.wav";